import layout from '@/layout'

export default {
  path: '/total',
  component: layout,
  redirect: '/total/ic',
  name: 'totalIc',
  meta: {
    title: 'total',
    icon: 'total'
  },
  children: [
    {
      path: '/total/ic',
      name: 'totalIc',
      component: () => import('@/views/total/ic/index'),
      meta: {
        title: 'totalIc',
        icon: 'total'
      }
    },
    {
      path: '/total/minute',
      name: 'totalMinute',
      component: () => import('@/views/total/minute/index'),
      meta: {
        title: 'totalMinute',
        icon: 'total'
      }
    },
    {
      path: '/total/dayk',
      name: 'totalDayK',
      component: () => import('@/views/total/dayk/index'),
      meta: {
        title: 'totalDayK',
        icon: 'total'
      }
    }
  ]
}
